// Tailwind base globals
import "@dust-tt/front/styles/global.css";
// Unified Tailwind build (sparkle + front + front-spa sources in one pass)
import "@spa/index.css";

import { astralyAppUrl } from "@dust-tt/front/lib/compta/astraly_urls";
import { stripBasePath } from "@dust-tt/front/lib/compta/base_path";
import { habillerAuDemarrage } from "@dust-tt/front/lib/compta/habillage";
import { modeIntegre } from "@dust-tt/front/lib/compta/mode_integre";
import { quitterLaVisiteDirecte } from "@dust-tt/front/lib/compta/visite_directe";
import App from "@spa/app/App";
import { demarrerSentrySpa } from "@spa/lib/erreurs_sentry";
import { initDatadogForSpa, initDatadogRUM } from "@spa/lib/initDatadog";
import React from "react";
import ReactDOM from "react-dom/client";

// Remarque de Louka du 31/10 : ouvert hors de la page Assistant de l'app, le chat y repart (une seule
// interface) ; rien n'est rendu pendant la redirection.
const enRedirection = quitterLaVisiteDirecte(
  window,
  modeIntegre(),
  astralyAppUrl(),
  stripBasePath(
    window.location.pathname + window.location.search,
    import.meta.env?.VITE_BASE_PATH ?? "/"
  )
);

// Sous-plan 10, lot B : avant le premier rendu, le theme et l'accent de l'app qui heberge le chat
// (document parent en mode integre, NEXT_PUBLIC_APP_ACCENT en visite directe).
habillerAuDemarrage(window, document, process.env.NEXT_PUBLIC_APP_ACCENT);

// compta : remontee des erreurs vers GlitchTip, inerte sans NEXT_PUBLIC_SENTRY_DSN.
demarrerSentrySpa();

// Initialize Datadog before rendering
initDatadogForSpa();
initDatadogRUM();

if (!enRedirection) {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Register the PWA service worker so the app is installable and launches standalone. The worker
// does no caching (see front/public/sw.js); failures are non-fatal and intentionally ignored.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Sous un sous-chemin (VITE_BASE_PATH=/chat/), le worker ne doit couvrir que la SPA.
    const base = import.meta.env?.VITE_BASE_PATH ?? "/";
    void navigator.serviceWorker
      .register(`${base}sw.js`, { scope: base })
      .catch(() => {});
  });
}
